export const GithubOnboarding = {
    convertGithubRepoName: 'api/ri/resource/name/1.0/github-repository-name',
    githubCopilotLicense: (email) => `api/azure/lookups/github/1.0/validate-github-copilot-license?emailId=${email}`,
    adGroupMember: (email) => `api/azure/lookups/github/1.0/validate-active-directory-group-member?emailId=${email}`,
    baseAdGroupMember: (email) => `api/azure/lookups/github/1.0/validate-active-directory-group-member?emailId=${email}&checkType=BASE_ONLY`,
    identifyUserType: (email) => `api/azure/lookups/github/1.0/identify-user-type?emailId=${email}`,
    capabilityTypes: 'api/static/lookups/1.0/github-capability-types',
    budgetCode: (payload) => `api/order/snow/1.0/budget-code/${payload.budgetCode}`,
    githubOrgUnit: 'api/azure/lookups/github/1.0/github-organizations',
    githubRepoValidate: (payload) => `api/azure/lookups/github/1.0/validate-github-repository/${payload.organizationUnit}/${payload.repositoryName}`,
    validateTeam: (payload) => `api/github/1.0/github/organizations/${payload.organizationUnit}/teams/${payload.teamName}/validate`,
    teamsList: (payload) => `api/github/1.0/github/organizations/${payload.organizationUnit}/users/${payload.userName}/teams`,
    templates: 'api/static/lookups/1.0/github-onboarding-templates',
    migrationSummary: 'api/github/1.0/github-migration-status',
    onboardingStatus: 'api/github/1.0/github-onboarding',
    validateGitAccount: (payload) => `api/github/1.0/github/organizations/${payload.organizationUnit}/verify-user/${payload.gpid}`,
    detectTechStack: 'api/github/1.0/jfrog-onboarding/detect-tech-stack',
    jfrogRepoDetails: 'api/github/1.0/jfrog-onboarding/repositories',
    projectOrganization: (projectName) => `api/security/tools/query/v1/azure/project?projectName=${projectName}`,
    branchDetails: (payload) => `api/github/1.0/jfrog-onboarding/${payload.organization}/${payload.projectName}/repos/${payload.repositoryName}/branches`,
    packageType: (payload) => `api/github/1.0/jfrog-onboarding/${payload.organization}/${payload.projectName}/repos/techstack`,
    validateSonarQube: 'api/github/1.0/tools-onboarding/validate/sonarqube',
    pipelineClassification: 'api/github/1.0/pipeline-classification',
    pipelineTemplates: 'api/static/lookups/1.0/github-pipeline-templates',
    adoRepositories: `api/github/1.0/ado/repositories`,
    resolveJfrogGlobalRepoName: 'api/github/1.0/jfrog-onboarding/resolve',
    validateJfrogRepoName: 'api/github/1.0/jfrog-onboarding/validate-repository',
    deploymentPatternValues: 'api/static/lookups/1.0/deployment-pattern-values',
    variableGroupExtraction: 'api/github/1.0/variable-group-extraction',
    argoCDConfigRepositories: (payload) =>
        `api/github/1.0/ado/repositories/argocd-configs?adoOrganization=${payload.adoOrganization}&adoProjectName=${payload.adoProjectName}`,
    convertGithubArgoCDRepoName: 'api/ri/resource/name/1.0/github-argocd-repository-name',
    Jwt: {
        submitOrder: 'api/day2/1.0/internal/order/github/submit',
        reSubmitOrder: 'api/day2/1.0/internal/order/github',
    },
};
export default GithubOnboarding;
